import { getNestedProperty } from './getNestedProperty';

export const getAccessToken = (auth) => {
  const target = getNestedProperty('authPayload', auth, auth);
  return getNestedProperty('token.accessToken', target);
};
